export const TRUE:boolean = true;
export const FALSE:boolean = false;